export const DEFAULT_FONT_SIZE = 13;
export const MIN_FONT_SIZE = 5;
export const MAX_FONT_SIZE = 21;
export const FONT_SIZE = [DEFAULT_FONT_SIZE, MIN_FONT_SIZE, MAX_FONT_SIZE];
export const ICON_FONT_SIZE = 15;
